$(document).ready(function() {
  'use strict';

  var fixed = document.getElementById('site_navigation');
  
  $('#nav_icon').click(function(){
    $(this).toggleClass('open');
    $('html, body, #site_navigation').toggleClass('nav-open');

    if($('body').hasClass('nav-open')) {
      fixed.addEventListener('touchmove', function(e) {
      console.log('nav-open');
      e.preventDefault();
    }, false);
    } else {
      fixed.removeEventListener('touchmove', function(e) {
          console.log('nav-closed');
          e.preventDefault();
      }, false);
    }
            
  });

  var $dropdown_parent = $('.menu-item-has-children');

  $dropdown_parent.hover(function(e){
    $(this).find($('.vertical.menu')).fadeIn();
  }, function(){
    $(this).find($('.vertical.menu')).fadeOut();
  });

  $('.menu-item-has-children .vertical.menu').hover(function(){
    //do nowt
  }, function(){
    $(this).fadeOut();
  });

  //info for gallery caption on mobile
  $('.open-info').click(function(){
    $('figcaption.caption').removeClass('open');
    $(this).parent('figcaption').addClass('open');
    $(this).closest('.slick-container').toggleClass('caption-open');
  });

  //info for availability on mobile
  $('.open-up').click(function(){
    $(this).parent('.slide-link-container').toggleClass('open');
    $(this).closest('.slick-container').toggleClass('caption-open');
  });

  var $slide_links = $('.slide-link-container'); 
  $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
    if($slide_links.length) {
      $slide_links.addClass('open');
    }
  });

});